import { helpers } from '@vuelidate/validators'

export default length =>
  helpers.withParams(
    { type: 'sameLength', length },
    value => !helpers.req(value) || (!!value && value.toString().length === length),
  )
